import { trackCioEvent } from '../cio';
import { formatCIOPhoneNumber, identifyUser } from '../identifyUser';
import { AnalyticsEvent } from '../types';

export type InsuranceSendLinkEventProperties = {
  primaryContactEmail: string;
  primaryContactPhoneNumber: string;
};

/**
 * Resume email/SMS for insurance send-link runs before order create, so the API
 * never identifies by `patient_uuid` on this path. Contact must be on the event
 * (and traits-only identify) — not via email-as-userId identify.
 */
export function trackInsuranceSendLink(properties: InsuranceSendLinkEventProperties) {
  const primaryContactPhoneNumber = formatCIOPhoneNumber(properties.primaryContactPhoneNumber);

  void identifyUser(properties.primaryContactEmail, {
    primaryContactEmail: properties.primaryContactEmail,
    primaryContactPhoneNumber,
  });

  trackCioEvent(AnalyticsEvent.DTC_INSURANCE_SEND_LINK, {
    primaryContactEmail: properties.primaryContactEmail,
    primaryContactPhoneNumber,
  });
}
